module.exports = __webpack_public_path__ + "media/fonts/Oricons-ee23cee5e312b1f7f5f86fc7816ac826.svg";